/**
 * Centralized error handling utility for The Gentle Mug theme
 * Provides consistent error logging and user feedback across all JavaScript files
 */

class ErrorHandler {
  /**
   * Log error to console with consistent formatting
   * @param {Error|string} error - The error to log
   * @param {string} context - Context where the error occurred (e.g., 'cart', 'product-form')
   */
  static logError(error, context = 'unknown') {
    const timestamp = new Date().toISOString();
    console.error(`[TGM Error] ${timestamp} [${context}]:`, error);
  }

  /**
   * Handle fetch errors with user feedback
   * @param {Error} error - The error object
   * @param {string} context - Context where the error occurred
   * @param {HTMLElement} targetElement - Optional element to show error message
   */
  static handleFetchError(error, context = 'unknown', targetElement = null) {
    this.logError(error, context);

    if (targetElement) {
      this.showUserMessage(targetElement, 'An error occurred. Please try again.', 'error');
    }
  }

  /**
   * Show user-friendly message
   * @param {HTMLElement} element - Element to display message in
   * @param {string} message - Message to display
   * @param {string} type - Message type: 'error', 'success', 'info'
   */
  static showUserMessage(element, message, type = 'info') {
    if (!element) return;

    const messageEl = document.createElement('div');
    messageEl.className = `tgm-message tgm-message--${type}`;
    messageEl.textContent = message;
    messageEl.setAttribute('role', 'alert');

    element.prepend(messageEl);

    // Auto-remove after 5 seconds
    setTimeout(() => {
      messageEl.remove();
    }, 5000);
  }
}

// Export for use in other modules
window.ErrorHandler = ErrorHandler;
